module.exports = __webpack_public_path__ + "img/tindak-lanjut.f8bda37a.svg";